@if (loading()) {
    <div class="toolbar-loading">
        <i class="pi pi-sync pi-spin"></i>
        <span>{{ 'QUOTE.DETAIL.LOADING_QUOTE' | translate }}</span>
    </div>
} @else {
    <div class="toolbar-container">
        <!-- Identity section -->
        <div class="toolbar-identity" [debugInspect]="quote()" debugInspectLabel="Quote">
            <!-- Status chip — small, always visible. Hover opens the full timeline. -->
            <button
                #statusAnchor
                type="button"
                class="status-chip"
                [class]="'status-chip--' + quoteStatusSeverity()"
                (mouseenter)="onStatusEnter($event, statusAnchor)"
                (mouseleave)="onStatusLeave()"
                (click)="statusPopover.toggle($event, statusAnchor)"
                [attr.aria-label]="quoteStatusLabel() | translate"
            >
                <span class="status-chip__dot" aria-hidden="true"></span>
                <i [class]="quoteStatusIcon()" class="status-chip__icon" aria-hidden="true"></i>
                <span class="status-chip__label">{{ quoteStatusLabel() | translate }}</span>
                <i class="pi pi-chevron-down status-chip__caret" aria-hidden="true"></i>
            </button>

            <p-popover
                #statusPopover
                styleClass="status-timeline-popover"
                [dismissable]="true"
                appendTo="body"
            >
                <div
                    class="status-timeline-popover__inner"
                    (mouseenter)="onPopoverEnter()"
                    (mouseleave)="onPopoverLeave()"
                >
                    @if (quote(); as q) {
                        <app-quote-status-timeline
                            [status]="q.status!"
                            [preDrawingStatus]="q.preDrawingStatus ?? null"
                            [statusLog]="statusLog()"
                            [drawerName]="drawer()?.name ?? null"
                            [drawerEmail]="drawer()?.email ?? null"
                            [estimatedCompletion]="estimatedCompletion() ?? null"
                            [isSubscription]="isSubscription()"
                            mode="expanded"
                        />
                    }
                </div>
            </p-popover>

            <span
                [pTooltip]="`${('QUOTE.DETAIL.TITLE_PREFIX' | translate)} ${quoteId()}`"
                tooltipPosition="bottom"
                class="toolbar-title"
            >
                #{{ quoteId() }}
                @if (hasFormerId()) {
                    <span class="toolbar-former-id">({{ 'BREADCRUMB.FORMER_ID' | translate }} #{{ quoteDisplayId() }})</span>
                }
            </span>

            <span class="toolbar-sep toolbar-sep--subtle">/</span>

            <span class="toolbar-customer" [pTooltip]="customerName()" tooltipPosition="bottom">
                {{ customerName() || '-' }}
            </span>

            <span class="toolbar-sep toolbar-sep--subtle">/</span>

            <span class="toolbar-project" [pTooltip]="projectName()" tooltipPosition="bottom">
                {{ projectName() || '-' }}
            </span>

            <span class="toolbar-sep toolbar-sep--subtle">/</span>

            <app-version-actions />
        </div>
    </div>
}
